import { Component, Input, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss']
})
export class CopyToClipboardComponent implements OnInit {

  @Input() title : string = "";
  @Input() api : string = "";

  constructor(private clipboard: Clipboard,
    private message: NzMessageService     ) { }

  ngOnInit() {
  }

  public copyToClipboardWithParameter(value: HTMLElement): void {
    const text: string = value.textContent || '';

    const successful = this.clipboard.copy(text);
    if (successful) {
      this.message.create('success', 'Copied to clipboard');
    }
  }
}
